import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import intro from 'intro.js'  //introjs库
import 'intro.js/introjs.css' // introjs默认css样式


// 加到prototype中。就能通过vue实例。用 $intro() 直接调用
Vue.prototype.$intro = intro

Vue.use(ElementUI);
Vue.config.productionTip = false

// 封装一个v-intro-if指令，这样就可以在循环中展示符合特定条件的引导了
// 当传过来的值是 true 的时候，不执行这个删除语句 
Vue.directive('intro-if', {
  bind: function (el,binding) {
    if (binding.value === false){
      delete el.dataset.intro
      delete el.dataset.hint
    }
  } 
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
